import React from 'react';
import { makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core';
import { Button } from 'rsuite';
import config from '@/configs/config';
import bbImage from './images/mobile_locationpartners_bb.png';
import dBbImage from './images/desktop_locationpartners_bb.png';
import pricingImage from './images/price.jpg';
import defaultTheme from './defaultTheme';

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    paddingBottom: theme.spacing(2),
  },
  bbContainer: {
    alignItems: 'center',
    backgroundImage: `url(${bbImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    color: 'white',
    display: 'flex',
    fontSize: 28,
    fontWeight: 'bold',
    height: 228,
    justifyContent: 'center',
    padding: theme.spacing(3),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      height: 661,
      backgroundImage: `url(${dBbImage})`,
    },
  },
  bbContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'start',
      width: '100%',
      fontSize: 54,
      height: 661,
      maxWidth: 768,
    },
  },
  bbButton: {
    background: theme.palette.primary.main,
    borderRadius: 4,
    color: 'black',
    fontSize: 14,
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.5, 3),

    [theme.breakpoints.up('sm')]: {
      fontSize: 28,
      marginTop: theme.spacing(3),
    },
  },
  bbDescription: {
    fontSize: 14,
    fontWeight: 'normal',
    [theme.breakpoints.up('sm')]: {
      fontSize: 24,
    },
  },
  content: {
    alignItems: 'center',
    color: '#4f4f4f',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      maxWidth: 768,
      fontSize: 16,
    },
  },
  contentTitle: {
    color: 'black',
    fontSize: 20,
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      fontSize: 40,
    },
  },
  contentBody: {
    marginTop: 12,
    color: '#4f4f4f',

    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
  contentImages: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: theme.spacing(5, 0),
    maxWidth: 768,

    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
  foodPicsContainer: {
    height: 508,
    position: 'relative',
    width: '100%',
  },
  foodPicsContent: {
    alignItems: 'center',
    background: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    fontWeight: 'bold',
    height: 350,
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-55%)',
    width: '100%',
  },
  planContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 'bold',
    justifyContent: 'center',
    padding: theme.spacing(3, 0),
    width: '100%',
    paddingBottom: 0,

    [theme.breakpoints.up('sm')]: {
      background: '#e9e9e9',
      paddingBottom: 0,
    },
  },
  planButtonContainer: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  planButton: {
    background: '#00a115',
    borderRadius: 4,
    color: 'white',
    fontSize: 27,
    padding: theme.spacing(0.5, 3),
  },
  planHeader: {
    border: 0,
    borderBottomWidth: 3,
    borderColor: 'black',
    borderStyle: 'solid',
    borderTopWidth: 3,
    boxSizing: 'border-box',
    fontSize: 20,
    padding: theme.spacing(1),
  },
  planBody: {
    color: '#ffb120',
    fontSize: 42,
    fontWeight: 'bold',
    marginTop: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      alignItems: 'end',
      display: 'flex',
      fontSize: 60,
      marginTop: 0,
    },
  },
  planFooter: {
    fontSize: 35,

    [theme.breakpoints.up('sm')]: {
      fontSize: 50,
    },
  },
  brandsContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
  },
  brandsHeader: {
    alignItems: 'center',
    background: theme.palette.primary.main,
    display: 'flex',
    fontSize: 40,
    fontWeight: 'bold',
    height: 92,
    justifyContent: 'center',
    width: '100%',
  },
  brandsBody: {
    padding: theme.spacing(3),
  },
  priceBg: {
    background: '#e9e9e9',
    bottom: 0,
    height: '15%',
    position: 'absolute',
    width: '100%',
  },
  featuresBg: {
    background: theme.palette.primary.main,
    height: '70%',
    position: 'absolute',
    width: '100%',
  },
  pricingContainer: {
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 768,
  },
  pricingImage: {
    width: '50%',
  },
  pricingImageImg: {
    width: '100%',
    height: 'auto',
  },
}));

export const Page = ({ formLink }) => {
  const classes = useStyle();

  console.log(formLink);

  return (
    <div className={classes.root}>
      <div className={classes.bbContainer}>
        <div className={classes.bbContent}>
          <span>鮮奶、豆漿、果汁家庭必須品</span>
          <span>免出門線上訂購下樓取貨</span>
          <span className={classes.bbDescription}>公司福委會唯一指定</span>
          <Button
            className={classes.bbButton}
            target="_blank"
            href={formLink}
          >
            立即諮詢
          </Button>
        </div>
      </div>
      <div className={classes.content}>
        <span className={classes.contentTitle}>社區合作方案</span>
        <div className={classes.contentBody}>
          <span>
            {config.BrandNameTW}
            是座落在城市中的迷你無人商店，為上班族帶來豐富的餐飲變化，解決上班族購餐方便性和吃膩的問題。
          </span>
          <span>每天都能享受不同的餐飲選擇及寶貴的休憩時刻，在忙碌的工作當中也能擁有真正屬於自己的自由時間。</span>
        </div>
        <ol className="fz-list-decimal fz-text-xl fz-font-bold">
          <li>鮮奶、優格、豆漿、果汁、布丁等新鮮配送</li>
          <li>優於市面零售價格</li>
          <li>社區免支付額外費用</li>
          <li>免出社區門即可輕鬆購買</li>
        </ol>
      </div>
      <div className={classes.planContainer}>
        <div className={classes.planBody}>迷你無人商店</div>
        <span className={classes.planFooter}>社區家庭的最愛</span>
        <div className={classes.planButtonContainer}>
          <Button
            className={classes.planButton}
            target="_blank"
            href={formLink}
          >
            請專人聯繫我

          </Button>
        </div>
        <div className="fz-container fz-m-x-auto fz-mt-8">
          <img src={pricingImage} alt="" width="100%" />
        </div>
      </div>
    </div>
  );
};

export default ({ formLink }) => {
  const theme = createMuiTheme(defaultTheme);

  return (
    <ThemeProvider theme={theme}>
      <Page formLink={formLink} />
    </ThemeProvider>
  );
};
